import { useEffect } from "react";

export const SITE_URL = process.env.REACT_APP_SITE_URL;
const BRAND = "SentinelGuide";
const DEFAULT_TITLE = "SentinelGuide — Understand Your Criminal Case, Rights & Next Steps";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const applySeo = ({ title, description, path = "/", noindex = false, jsonLd }) => {
  const fullTitle = title ? `${title} | ${BRAND}` : DEFAULT_TITLE;
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;
  document.title = fullTitle;
  setMeta("name", "description", description);
  setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
  setMeta("property", "og:title", fullTitle);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", url);
  setMeta("name", "twitter:title", fullTitle);
  setMeta("name", "twitter:description", description);
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = url;
  document.getElementById("page-jsonld")?.remove();
  if (jsonLd) {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = "page-jsonld";
    s.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(s);
  }
};

export const Seo = (props) => {
  const key = JSON.stringify(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => applySeo(props), [key]);
  return null;
};

export const breadcrumbs = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE_URL}${it.path}` })),
});
